<template>
    <div class="Experience">
        <!-- <Section v-if="!$root.isDesk"/> -->
        <!-- <Game v-if="$root.isDesk"/> -->
        <Game ref="game" v-if="useGame"/>
        <!-- <HandsFree ref="hands" v-if="useHands"/> -->
        <Gesture v-if="$route.params.model == 'handpose'"/>
        <HandPoseDetection v-if="$route.params.model == 'handposedetection'"/>
        <FingerPose v-if="$route.params.model == 'finger'"/>
        <Squat v-if="$route.params.model == 'squat'"/>
        <Pose v-if="$route.params.model == 'pose'"/>
        <Face v-if="$route.params.model == 'glasses'"/>
        <Parlement v-if="$route.params.model == 'parlement'"/>
        <Fast v-if="$route.params.model == 'fast'"/>
        <Accelerometer v-if="$route.params.model == 'writing'"/>
    </div>
</template>

<script>

import Section from '@/components/Section.vue'
import Desktop from '@/components/Desktop.vue'
import Game from '@/components/Game.vue'
import HandsFree from '@/components/HandsFree.vue'
import HandPoseDetection from '@/components/HandPoseDetection.vue'
import FingerPose from '@/components/FingerPose.vue'
import Gesture from '@/components/Gesture.vue'
import Squat from '@/components/Knn.vue'
import Pose from '@/components/Pose.vue'
import Face from '@/components/Face.vue'
import Parlement from '@/components/Parlement.vue'
import Fast from '@/components/Fast.vue'
import Accelerometer from '@/components/Accelerometer.vue'

export default {
    name: 'Experience',
    components: { Section, Desktop, Game, HandsFree, Gesture, HandPoseDetection, FingerPose, Squat, Pose, Face, Parlement, Fast, Accelerometer },
    data: () => ({
        useHandPoseDetection: false,
        useHands: false,
        useGame: false
    }),
    mounted() {
        document.addEventListener('keyup', this.onKey)
    },
    methods: {
        onKey(evt) {

            // if(evt.keyCode == 32) 
            //     this.useHands = true

            if(evt.keyCode == 71) {
                // if(this.useHands)
                    // this.$refs.hands.removeScreens() 
                this.useGame = true 
            } 

            // if(evt.keyCode == 72) 
            //     this.useHandPoseDetection = true      
        },
    }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Experience
    display block
    position absolute
    top 0
    left 0
    width 100vw
    height 100%
    // background green

</style>




